import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import useResourceUserProfileRolesQuery from './useResourceUserProfileRolesQuery';
import RolesDisplayList from './RolesDisplayList';

const UserProfileRolesList = ({ userId }) => {
  const { loading, profileRoles } = useResourceUserProfileRolesQuery({
    userId
  });

  const roleEntries = useMemo(
    () =>
      profileRoles.map(r => ({
        projectRole: { id: r.roleUri, displayText: r.displayText },
        isDefault: r.isDefault
      })),
    [profileRoles]
  );

  if (!loading && roleEntries.length === 0) {
    return null;
  }

  return <RolesDisplayList roles={roleEntries} loading={loading} />;
};

UserProfileRolesList.propTypes = {
  userId: PropTypes.string.isRequired
};

export default UserProfileRolesList;
